import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { SortOptions, SortType } from '../../enums/SORT';
import { ACCESS_TYPE, ACCESS_TYPE_ENUM, ACCESS_TYPE_KEYS } from '../../enums/ACCESS_ENUM';
import { getSharedWithMePageSortOptionAndType } from '../../helpers';

export const getAllComposers = async (data: { page?: number; limit?: number; search?: string; sort?: string; sortOption: SortOptions }) => {
  const { page = 1, limit = 10, search = '', sort, sortOption } = data;
  const res = await axiosInstance.get(
    `${API_ROUTES.REFLEX_COMPOSER}?page=${page + 1}&limit=${limit}&sort=${sort || 'asc'}&search=${search}&sortField=${
      sortOption || SortOptions.NAME
    }`,
  );
  return res;
};

export const getAllWithoutQueryComposers = async (sort?: string, sortField?: string) => {
  if (sort && sortField) {
    const res = await axiosInstance.get(`${API_ROUTES.REFLEX_COMPOSER}${sort}${sortField}`);
    return res;
  } else {
    const res = await axiosInstance.get(`${API_ROUTES.REFLEX_COMPOSER}`);
    return res;
  }
};

export const getAllSharedComposersWithoutQuery = async () => {
  const sortRes = getSharedWithMePageSortOptionAndType();
  if (sortRes) {
    const sortAndOption = sortRes.split('/');
    if (sortAndOption[0] && sortAndOption[1]) {
      const sort = `?sort=${sortAndOption[0]}`;
      const sortField = `&sortField=${sortAndOption[1]}`;
      const res = await axiosInstance.get(`${API_ROUTES.REFLEX_COMPOSER_SHARED_WITH_ME}${sort}${sortField}`);
      return res;
    }
  } else {
    const res = await axiosInstance.get(`${API_ROUTES.REFLEX_COMPOSER_SHARED_WITH_ME}?sort=${SortType.ASC}&sortField=${SortOptions.NAME}`);
    return res;
  }
};

export const getSharedComposers = async (data: {
  page?: number;
  limit?: number;
  search?: string;
  sort?: string;
  sortOption: SortOptions;
  accessType?: ACCESS_TYPE_ENUM[];
}) => {
  const { page = 1, limit = 10, search = '', sort, sortOption, accessType } = data;
  const res = await axiosInstance.get(
    `${API_ROUTES.REFLEX_COMPOSER_SHARED_WITH_ME}?page=${page + 1}&limit=${limit}&sort=${
      sort || SortType.ASC
    }&search=${search}&sortField=${sortOption}${accessType ? `&accessType=${JSON.stringify(accessType)}` : ''}`,
  );
  return res;
};

export const deleteComposer = async (data: { composerId: string }) => {
  const { composerId } = data;
  const res = await axiosInstance.delete(`${API_ROUTES.REFLEX_COMPOSER}/${composerId}`);
  return res;
};

export const deleteTopicInReflexComposer = async (topicId: string, videoFeedId: string) => {
  const res = await axiosInstance.delete(`${API_ROUTES.REFLEX_COMPOSER_TOPIC}/${topicId}/${videoFeedId}`);
  return res;
};
